export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const observationData = state => state.observationData
export const observationViolations = state => state.observationViolations
export const deletedSuccess = state => state.deletedSuccess
